import { Component, OnInit } from '@angular/core';
import { NavController, MenuController } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { NavigationExtras } from '@angular/router';
import { ApiRestServicesService } from './api-rest-services.service';

// Push Notifications
import { OneSignal } from '@ionic-native/onesignal/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent implements OnInit {

  UserName: String  = "Usuario(a)";
  FirstL: String;
  public appPages = [
    {
      title: 'Inicio',
      url: '/home',
      icon: 'home'
    },
    {
      title: 'Buscar',
      url: '/search',
      icon: 'search'
    },
    {
      title: 'Favoritos',
      url: '/favoritos',
      icon: 'heart'
    },
    {
      title: 'Categorias',
      url: '/categorys',
      icon: 'apps'
    },
    {
      title: 'Carrito de compras',
      url: '/cart-shop',
      icon: 'cart'
    }
  ];

  constructor(
    private Api: ApiRestServicesService,
    private platform: Platform,
    private nav: NavController,
    private menu: MenuController,
    public oneSignal: OneSignal
  ) {
    this.initializeApp();
  }

  ngOnInit() {
    this.Api.User$.subscribe( (stat) => {
      if (stat) {
        let data = JSON.parse(window.localStorage.getItem('DataUser'));
        this.UserName = data.Cliente.Nombre + ' ' + data.Cliente.Ap;
        this.FirstL   = data.Cliente.Nombre[0];
        this.FirstL   = this.FirstL.toLocaleUpperCase();
      }
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.oneSignal.startInit('46178d80-a1cc-4eb0-a94c-e0018303e98f', '153645666481');
      this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);
      this.oneSignal.handleNotificationReceived().subscribe(() => {
      // do something when notification is received
      });
      this.oneSignal.handleNotificationOpened().subscribe(() => {
        // do something when a notification is opened
      });
      this.oneSignal.endInit();
      if (window.localStorage.getItem('DataUser')) {
        let DataUser = JSON.parse(window.localStorage.getItem('DataUser'));
       
        this.Api.PhoneVerify(DataUser.Phone).then( res => {
          window.localStorage.setItem('DataUser',JSON.stringify(res['data'][0]));
          this.Api.GetContactAdmin().then( data => {
            window.localStorage.setItem('PhoneContact', data['data'][0]['Phone']);
          });
          // Redireccionar
          let navigationExtras: NavigationExtras = {
            queryParams: {
              RedirectTo: 'home'
            }
          };
          this.nav.navigateForward(['ini'], navigationExtras); 
        }); 
      }else {
        // let navigationExtras: NavigationExtras = {
        //   queryParams: {
        //     RedirectTo: 'welcome'
        //   }
        // };
        // this.nav.navigateForward(['ini'], navigationExtras);  
      }
    });
  }

  NavPush(Page) {
    this.nav.navigateForward(Page);
    this.menu.close();
  }

  CloseSession() {
    window.localStorage.removeItem('DataUser');
    this.UserName = '';
    this.FirstL   = '';
    this.FirstL   = '';
    this.menu.enable(false);
    let navigationExtras: NavigationExtras = {
      queryParams: {
        RedirectTo: 'welcome'
      }
    };
    this.nav.navigateForward(['ini'], navigationExtras);  
  }
}